<script lang="ts" setup>

//vue
import { onMounted, reactive } from "vue";
import { useRoute } from 'vue-router';

//servicos
import config from "@/app.config.json";
import * as service from "@/services/relatoriosService";
import * as mensalidadesService from "@/services/mensalidadesService";
import { fdata, f2dec, fdataUS, fDifData } from "@/utils/funcoes";

//componentes
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import TrataTecla from "@/components/TrataTecla/Index.vue";
import Notificacao from "@/components/Notificacao/Index.vue";
import MsgBox from "@/components/MsgBox/Index.vue";


const route = useRoute();

var controle = reactive({

  filtros: {
    nome: "",
    ano: 2026 ,
    mes: 7,
    status: "A Receber",
  } as unknown as service.FiltroMensalidades,
  cidadeId: null as number | null,
  itens: [] as service.RelMensDTO[],

  ordenarPor: "dataPagamento",
  ordenarDir: "asc",

  totalRegistros: 0,

  qtdeRegistros: 0,
  qtdePagos: 0,
  qtdeEmAberto: 0,
  qtdeVencidos: 0,

  totalGeral: 0,
  totalPago: 0,
  totalEmAberto: 0,
  totalVencido: 0,
  totalAcresDesc: 0,

  erro: "",
  status: "",
  pesquisando: false,

  janConfirmaPagamento: false,
  itemPagando: null as service.RelMensDTO | null,
  statusPagamento: "",
  erroPagamento: "",
})

onMounted(() => {

  if (route.params.id != null && route.params.id !== "") {
    controle.filtros.contratoId = parseInt(route.params.id.toString());
    controle.filtros.ano = null;
    controle.filtros.mes = null;
    controle.filtros.status = null;
  }
  else 
  {
    controle.filtros.ano = parseInt(new Date().getFullYear().toString());
    controle.filtros.mes = parseInt((new Date().getMonth() + 1).toString().padStart(2, '0'));
  }
  pesquisar();
})

async function pesquisar() {

  if (controle.cidadeId != null && controle.cidadeId > 0) {
    controle.filtros.cidadesIds = [controle.cidadeId];
  } else {
    controle.filtros.cidadesIds = null;
  }

  if (controle)

  service.mensalidades(controle.filtros)
    .then(r => {
      controle.itens = r.dados;
      ordenarPor("dataPagamento");

      controle.totalRegistros = r.totalRegistros;
      controle.pesquisando = false;

      controle.qtdeRegistros = controle.itens.length;
      controle.qtdeEmAberto = 0;
      controle.qtdePagos = 0;
      controle.qtdeVencidos = 0;

      controle.totalGeral = 0;
      controle.totalEmAberto = 0;
      controle.totalPago = 0;
      controle.totalVencido = 0;
      controle.totalAcresDesc = 0;

      controle.itens.forEach(a => {

        controle.totalGeral += a.valor;

        if (a.dataPagamento != null) {
          controle.qtdePagos += 1;
          controle.totalPago += a.valorPago;
          controle.totalAcresDesc += a.valorPago - a.valor;
        }

      });

    })
    .catch(erro => {
      controle.erro = erro;
      controle.pesquisando = false;
    })
}

const ordenarPor = (coluna: string) => {

  controle.itens = controle.itens.sort((a, b) => {
    return (a[coluna] > b[coluna]) ? 1 : ((b[coluna] > a[coluna]) ? -1 : 0);
  }) as service.RelMensDTO[];
}

function boleto(item: service.RelMensDTO) {
  if (item.boletoId == null) {
    controle.erro = "Boleto não gerado.";
    return;
  }
  else
  {
    const urlBase = `${config.urlApi}`

    var url = `${urlBase}/Boletos/Ver/${item.boletoId}`;
    
    if (item.boletoAntigo)
      url = `${urlBase}/Boletos/VerAntigo/${item.boletoId}`;

    window.open(url, '_blank');
  }
}

function confirmarPagamento(item: service.RelMensDTO) {
  controle.itemPagando = item;
  controle.erroPagamento = "";
  controle.janConfirmaPagamento = true;
}

function pagarConfirmado() {
  if (!controle.itemPagando) return;

  controle.statusPagamento = "Registrando pagamento...";
  controle.erroPagamento = "";

  mensalidadesService.pagar(controle.itemPagando.id)
    .then(() => {
      controle.statusPagamento = "";
      controle.itemPagando = null;
      pesquisar();
    })
    .catch((error) => {
      controle.erroPagamento = `Erro ao registrar pagamento: ${error.message || error}`;
      controle.statusPagamento = "";
    });
}

function pix(item: service.RelMensDTO) {
  
  if (item != null)
  {
    controle.erro = "Desativado";
    return;
    
  }
  
  if (item.boletoId == null) {
    controle.erro = "PIX não gerado.";
    return;
  }
  else
  {
    const urlBase = `${config.urlApi}`

    var url = `${urlBase}/Boletos/Ver/${item.boletoId}`;

    window.open(url, '_blank');
  }
}

</script>

<template>
  <BreadCrumb PageTitle="Contas a Receber" :items="[
    { label: 'Relatorios', to: '/' }]" />

  <Notificacao :erro="controle.erro" @limparErro="controle.erro = ''" :progresso="controle.status"
    @limparProgresso="controle.status = ''" />

  <TrataTecla>
    <div class="card" style="margin-bottom: 100px;">
      <div class="card-body">
        <div class="row">

          <!-- coluna 1-->
          <div class="col-md-12">
            <div class="row mb-2">

              <div class="col-md-2 col-6">
                <label>Nome ou CPF</label>
                <input v-model="controle.filtros.nome" class="form-control form-control-sm" id="nome" :type="'text'"
                  @input="pesquisar" />
              </div>

              <div class="col-md-2 col-6">
                <label>Nro Contrato</label>
                <input v-model="controle.filtros.contratoId" class="form-control form-control-sm" id="contrato" :type="'text'"
                  @input="pesquisar" />
              </div>

               <div class="col-md-2 col-6">
                <label>Mês</label>
                <select v-model="controle.filtros.mes" class="form-select form-select-sm" id="mes"
                  @change="pesquisar">
                  <option :value="null">Todos</option>
                  <option :value="1">Janeiro</option>
                  <option :value="2">Fevereiro</option>
                  <option :value="3">Março</option>
                  <option :value="4">Abril</option>
                  <option :value="5">Maio</option>
                  <option :value="6">Junho</option>
                  <option :value="7">Julho</option>
                  <option :value="8">Agosto</option>
                  <option :value="9">Setembro</option>
                  <option :value="10">Outubro</option>
                  <option :value="11">Novembro</option>
                  <option :value="12">Dezembro</option>
                </select>
              </div>

              <div class="col-md-2 col-6">
                <label>Ano</label>
                <select v-model="controle.filtros.ano" class="form-select form-select-sm" id="ano"
                  @change="pesquisar">
                  <option :value="null">Todos</option>
                  <option :value="'2022'">2022</option>
                  <option :value="'2023'">2023</option>
                  <option :value="'2024'">2024</option>
                  <option :value="'2025'">2025</option>
                  <option :value="'2026'">2026</option>
                  <option :value="'2027'">2027</option>
                  <option :value="'2028'">2028</option>
                  <option :value="'2029'">2029</option>
                  <option :value="'2030'">2030</option>
                  <option :value="'2031'">2031</option>
                  <option :value="'2032'">2032</option>
                </select>
              </div>

              <div class="col-md-2 col-6">
                <label>Status</label>
                <select v-model="controle.filtros.status" class="form-select form-select-sm" id="status"
                  @change="pesquisar">
                  <option :value="null">Todos</option>
                  <option :value="'A Receber'">Em Aberto</option>
                  <option :value="'Vencidas'">Vencidas</option>
                  <option :value="'Pago'">Pago</option>
                </select>
              </div>


              <div class="col-md-2 col-6">
                <a class="btn btn-primary btn-sm mt-4" @click="pesquisar">Pesquisar</a>

                <RouterLink class="btn btn-sm btn-secondary float-end mt-4" :to="'/'">Fechar</RouterLink>
              </div>

            </div>
          </div>

        </div>

        <div class="col-md-12 table-responsive">

          <div v-if="controle.erro != ''" class="col-md-12 text-center">
            <div class="p-4">
              <div class="fw-14 text-danger"> {{ controle.erro }}</div>
            </div>
          </div>

          <div v-if="controle.erro == '' && controle.pesquisando == true" class="col-md-12 text-center">
            <div class="p-4">
              <i class="fa fa-cog fa-2x fa-spin"></i>
              <div class="fw-16">Pesquisando...</div>
            </div>
          </div>

          <template v-if="controle.erro == '' && controle.pesquisando == false">

            <div class="mb-1 text-muted f12px">Total: {{ controle.totalRegistros }} registro(s)</div>

            <table class="table-sm table-bordered" id="tabela-relatorio">
              <thead>
                <tr class="table-relatorio">
                  <th class="text-start text-truncate colNome">Nome</th>
                  <th class="text-end">Cliente</th>
                  <th class="text-center">Parcela <br> Contrato</th>
                  <th class="text-end">Valor R$</th>
                  <th class="text-end" >Pago R$</th>
                  <th class="text-end">Acres<br>Desc R$</th>
                  <th class="text-center">Vencimento</th>
                  <th class="text-center" >Pagamento</th>
                  <th class="text-center">Dias Atraso</th>
                  <th class="text-center">Opções</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, idx) in controle.itens" :key="idx">
                  <td class="text-start text-truncate colNome">{{ item.clienteNome }}</td>
                  <td class="text-end">{{ item.clienteId }}</td>
                  <td class="text-center">{{ item.parcela }} / {{ item.contratoId }}</td>
                  <td class="text-end">{{ f2dec(item.valor) }}</td>
                  <td class="text-end" :class="item.valorPago > 0 ? 'fw-bold' : ''">{{ f2dec(item.valorPago) }}</td>
                  <td class="text-end"  >{{ f2dec(item.valorPago > 0 ? item.valorPago - item.valor : 0) }}</td>
                  <td class="text-center">
                    <span  class="badge rounded-pill" :class=" fDifData(new Date(), item.dataVencimento) > 0 ? 'badge-soft-danger': 'badge-soft-primary'"> {{ fdata(item.dataVencimento) }}</span></td>
                  <td class="text-center">{{ fdata(item.dataPagamento) }}</td>
                  <td class="text-center">{{ fDifData(new Date(), item.dataVencimento) }}</td>
                  <td class="text-center text-nowrap">

                    <a class="btn btn-sm me-1" :class="item.boletoAntigo ? 'btn-primary' : 'btn-danger'" title="Imprimir boleto"
                      @click="boleto(item)"
                      v-if="item.boletoId  && item.dataPagamento == null && item.podeImprimir">
                      <i class="fa fa-barcode"></i> Boleto
                    </a>

                    <a class="btn btn-sm btn-primary me-1"
                    title="Obter código Pix"
                    @click="pix(item)"
                    v-if="item.boletoId  && item.dataPagamento == null && item.podeImprimir"
                    disabled>
                      <i class="fa fa-qrcode"></i> Pix
                    </a>

                    <a class="btn btn-sm btn-success" title="Pagar" @click="confirmarPagamento(item)"
                      v-if="item.dataPagamento == null">
                      <i class="fa fa-check"></i> Pagar
                    </a>
                  </td>
                </tr>
                <tr class="border-top">
                  <td></td>
                  <td></td>
                  <td></td>
                  <td class="text-end fw-bold">{{ f2dec(controle.totalGeral) }}</td>
                  <td class="text-end fw-bold" >{{ f2dec(controle.totalPago) }}</td>
                  <td class="text-end fw-bold">{{ f2dec(controle.totalAcresDesc) }}</td>
                  <td></td>
                  <td></td>
                </tr>
              </tbody>

            </table>

          </template>

        </div>
      </div>

    </div>






  </TrataTecla>

  <MsgBox :id="'janConfirmaPagamentoContasReceber'" class="modal-md" data-bs-backdrop="static"
    :exibir="controle.janConfirmaPagamento" :titulo="'Atenção'"
    @on-fechou="controle.janConfirmaPagamento = false; controle.itemPagando = null" :botao-sim="true"
    :botao-nao="true" @on-sim="pagarConfirmado()">
    <div class="row mb-2">
      <div class="col-md-12 fs-5 fw-bold text-center ">
        Confirma o pagamento?
      </div>
    </div>
    <div class="row" v-if="controle.itemPagando">
      <div class="col-md-12 text-center">
        {{ controle.itemPagando.clienteNome }} - Parcela {{ controle.itemPagando.parcela }} - R$ {{ f2dec(controle.itemPagando.valor) }}
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-md-12 text-center">
        <span class="">{{ controle.statusPagamento }}</span>
        <span class="text-danger fw-bold">{{ controle.erroPagamento }}</span>
      </div>
    </div>
  </MsgBox>

</template>

<style lang="scss" scoped>
.colNome {
  width: 250px;
}
</style>